import React from 'react';
import TermItemSelectField from '../../../../Term/Components/TermItemSelectField';
import { BaseFieldProps } from '../../Inputs/BaseField/BaseField';

const P1DiseasesField: React.FC<BaseFieldProps> = props => {
	return <TermItemSelectField {...props} termType='p1_idc10_diseases' />;
};

export default P1DiseasesField;
